import axios from "@/api/axios";

export async function createCity({ cityName }) {
  const { data } = await axios.post("/cities", { cityName });
  return data;
}

export async function updateCity(id, payload) {
  const { data } = await axios.patch(`/cities/${id}`, payload);
  return data;
}

export async function setCityEnable(id, isEnable) {
  const { data } = await axios.patch(`/cities/enables/${id}`, { isEnable });
  return data;
}

export async function setCityOperation(id, inOperation) {
  const payload = {
    cityStatus: inOperation ? "available" : "retired",
    isEnable: inOperation,
  };
  const { data } = await axios.patch(`/cities/enables/${id}`, payload);
  return data;
}
